import styles from "./OrderTypeSelector.module.css";
import { OrderFulfillmentType, OrderType } from "~/entities/orderEntities";
import OrderTypePickupIcon from "~/icons/OrderTypePickupIcon";
import OrderTypeDeliveryIcon from "~/icons/OrderTypeDeliveryIcon";
import clsx from "clsx";

type OrderTypeSelectorProps = {
  onChange: (value: OrderType) => void;
  orderTypes: OrderType[];
  selectedOrderType: OrderType | undefined;
  withIcons?: boolean;
};

const OrderTypeSelector: React.FC<OrderTypeSelectorProps> = ({
  onChange,
  selectedOrderType,
  orderTypes,
  withIcons = true,
}) => {
  return (
    <div className={styles.orderTypeButtons}>
      {orderTypes
        .filter(
          (type) => type.fulfillmentType !== OrderFulfillmentType.IN_STORE
        )
        .map((orderType) => (
          <div
            key={orderType.code}
            className={clsx(
              styles.orderTypeButton,
              orderType.code === selectedOrderType?.code &&
                styles.orderTypeButtonSelected
            )}
            onClick={() => onChange(orderType)}
          >
            {withIcons &&
            orderType.fulfillmentType === OrderFulfillmentType.DELIVERY ? (
              <OrderTypeDeliveryIcon />
            ) : (
              <OrderTypePickupIcon />
            )}
            <span>{orderType.name}</span>
          </div>
        ))}
    </div>
  );
};

export default OrderTypeSelector;
